<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :z-index="zIndex"></loading>
    <b-modal id="modalDeleteExpertise" ref="modalDeleteExpertise" title="Confirm">
      <p>Do you really want to remove the registry?</p>
      <p><b>Description: </b> <span v-if="expertise.agencyAreaOfExpertise">{{ expertise.agencyAreaOfExpertise.name }}</span></p>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="confirmDeleteExpertise">Confirm</b-button>
          <b-button variant="secondary" @click="hideModalDeleteExpertise">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalExpertise" ref="modalExpertise" size="lg" title="Add expertise">
      <b-row>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Expertise <span class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-select v-model="expertise.agencyAreaOfExpertiseId" :state="$v.expertise.agencyAreaOfExpertiseId.$dirty ? !$v.expertise.agencyAreaOfExpertiseId.$error : null" :options="expertiseOptions" value-field="id" text-field="name"></b-form-select>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Month of experience <span class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-input id="name-input" v-model="expertise.monthOfExperience" :state="$v.expertise.monthOfExperience.$dirty ? !$v.expertise.monthOfExperience.$error : null" type="number" required></b-input>
            </div>
          </div>
        </b-col>
      </b-row>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="saveExpertise">Save</b-button>
          <b-button variant="secondary" @click="hideModalExpertise">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalEditExpertise" ref="modalEditExpertise" size="lg" title="Edit expertise">
      <b-row>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Expertise</label>   
            <div v-if="expertise.agencyAreaOfExpertise" class="input-group"> 
              {{ expertise.agencyAreaOfExpertise.name }}
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Month of experience <span class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-input id="name-input" v-model="expertise.monthOfExperience" :state="$v.expertise.monthOfExperience.$dirty ? !$v.expertise.monthOfExperience.$error : null" type="number" required></b-form-input>
            </div>
          </div>
        </b-col>
      </b-row>
      <template slot="modal-footer">
        <b-button variant="primary" class="mr-2" @click="saveEditExpertise">Save</b-button>
        <b-button variant="secondary" @click="hideModalEditExpertise">Close</b-button>
      </template>
    </b-modal>
    <div class="card-body">
      <h5 class="card-title mt-4">Area of expertise</h5>
      <div class="row">
        <div class="col-md-6 col-sm-9 col-xs-12">
          <b-table hover :items="expertiseItems" :fields="expertiseFields">
            <template v-slot:cell(Options)="row">
              <b-button v-b-tooltip.hover title="Edit" variant="primary" size="xs" @click="editExpertise(row.item)"><i class="far fa-edit"></i></b-button>
              <b-button v-b-tooltip.hover title="Remove" variant="danger" size="xs" class="ml-2" @click="deleteExpertise(row.item)"><i class="far fa-trash-alt"></i></b-button>
            </template>
            <template v-slot:cell(monthOfExperience)="row">
              {{ row.item.monthOfExperience }} month(s)
            </template>
          </b-table>
          <b-button variant="primary" @click="addExpertise">Add area of expertise</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from '@src/app.config'
import { authMethods, authComputed } from '@state/helpers'
import loading from 'vue-loading-overlay'
import axios from 'axios'
import 'vue-loading-overlay/dist/vue-loading.css'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';

var qs = require('qs')

export default {
  components: { loading },
  mixins: [validationMixin],
  props: {
    id: { type: String, default: () => ({}) }
  },
  data () {
    return {
      CurriculumId: this.id,
      educationItems: [],
      expertiseFields: [
      {
        key: 'agencyAreaOfExpertise.name',
        label: 'Description'
      },
      {
        key: 'monthOfExperience',
        label: 'Experience'
      },
      {
        key: 'Options',
        label: 'Options',
        thStyle: {width: '120px !important'}
      }
     ],
      expertiseItems: [],
      expertiseOptions: [],
      expertise: {},
      isLoading: false,
      fullPage: false,
      zIndex: 9999,
      requiredFields: []
    }
  },
  validations() {
    return {
      expertise: {
        monthOfExperience: { required },
        agencyAreaOfExpertiseId: { required }
      }
    }
  },
  computed: {
    ...authComputed
  },
  created () {
    this.loadExpertise()
    this.loadRequiredFields()
  },
  methods: {
    ...authMethods,
    loadRequiredFields () {
      axios.get(`${appConfig.apiUrl}required-fields/${this.currentAgency.id}/only/education`,
      { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.requiredFields = response.data
      })
    },
    checkDynamicRequired (field) {
      if (this.requiredFields.find(f => f.aliasId === field && f.selected === true)) {
        return { required }
      }
      return {}
    },
    checkLabelRequired (field) {
      if (this.requiredFields.find(f => f.aliasId === field && f.selected === true)) {
        return true
      }
      return false
    },
    loadExpertise () {
      this.isLoading = true
      axios.get(appConfig.apiUrl + 'area-of-expertise/candidate/' + this.CurriculumId,
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
        .then((response) => {
          if(response.data) {
            this.expertiseItems = response.data
            this.isLoading = false
          }
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        })
    },
    addExpertise () {
      this.isLoading = true
      this.expertise = {}
      axios.get(appConfig.apiUrl + 'area-of-expertise/' + this.currentAgency.id,
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
        .then((response) => {
          if(response.data) {
            if(response.data.length > 0) {
              this.expertiseOptions = response.data
              this.$refs['modalExpertise'].show()
            } else {
              this.$notify({group: 'alert', type: 'info', title: 'Information', text: 'No have area of expertise avaible.'});
            }
            this.isLoading = false
          }
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        })
    },
    editExpertise (item) {
      this.expertise = item
      this.expertise.agencyAreaOfExpertiseId = item.agencyAreaOfExpertise.id
      this.$refs['modalEditExpertise'].show()
    },
    saveExpertise () {
      this.$v.expertise.$touch()
      if (this.$v.expertise.$anyError) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.'});
        return
      }

      axios.post(appConfig.apiUrl + 'area-of-expertise/candidate/save',
        qs.stringify({
          CurriculumId: this.CurriculumId,
          AgencyAreaOfExpertiseId: this.expertise.agencyAreaOfExpertiseId,
          MonthOfExperience: this.expertise.monthOfExperience
        }),
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Saved Successful.'});
          this.loadExpertise()
          this.$emit('reload-curriculum')
          this.hideModalExpertise()
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    saveEditExpertise () {
      this.$v.expertise.$touch()
      if (this.$v.expertise.$anyError) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.'});
        return
      }

      axios.put(appConfig.apiUrl + 'area-of-expertise/candidate/update',
        qs.stringify({
          CurriculumId: this.CurriculumId,
          AgencyAreaOfExpertiseId: this.expertise.agencyAreaOfExpertiseId,
          MonthOfExperience: this.expertise.monthOfExperience
        }),
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Saved Successful.'});
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.loadExpertise()
          this.hideModalEditExpertise()
          this.$emit('reload-curriculum')
          this.isLoading = false
        })
    },
    hideModalExpertise () {
      this.$refs['modalExpertise'].hide()
      this.$v.expertise.$reset()
    },
    hideModalEditExpertise () {
      this.$refs['modalEditExpertise'].hide()
      this.$v.expertise.$reset()
    },
    hideModalDeleteExpertise () {
      this.$refs['modalDeleteExpertise'].hide()
    },
    deleteExpertise (item) {
      this.expertise = item
      this.$refs['modalDeleteExpertise'].show()
    },
    confirmDeleteExpertise () {
      this.isLoading = true
      axios.delete(appConfig.apiUrl + `area-of-expertise/candidate/${this.CurriculumId}/agency-area-of-expertise/${this.expertise.agencyAreaOfExpertiseId}`,
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Deleted Successful.'});
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.loadExpertise()
          this.isLoading = false
          this.$emit('reload-curriculum')
          this.hideModalDeleteExpertise()
        })
    }
  }
}
</script>
